import { Component, OnInit, Input, OnDestroy,ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppService } from '../../services/app.service';
import { Provlookup } from '../../models/provlookup';
import { PlaceDropDown } from '../../models/placedropdown';


@Component({
  selector: 'app-provider-lookup',
  templateUrl: './provider-lookup.component.html',
  styleUrls: ['./provider-lookup.component.css']
})
export class ProviderLookupComponent implements OnInit, OnDestroy {

  @Input() lookupForm: FormGroup;
  @Input() lookupProvForm: FormGroup;
  @Input() _hpCodes: string = '';
  @Input() _image: string = '';

  public defaultLogo: string = "DRC";
  public combined: boolean = false;
  public seperate: boolean = false;
  public size: number = 0;
  public sizer: any;
  public currentpage = 1;
  public defaultSuburb: string = "";
  public area: boolean = false;
  public provider: boolean = false;

  constructor(private fb: FormBuilder, private fbP: FormBuilder, public _appService: AppService, private cdr: ChangeDetectorRef) {
    this.size = window.innerWidth;
    if (this.size > 1280) {
      this.combined = false;
      this.seperate = true;
    }

    if (this.size <= 1280) {
      this.combined = true;
      this.seperate = false;
    }
    console.log("construct");

    console.log(this._appService.LookUpService.showJoinDate);

   
  }

  ngOnInit() {

    this.lookupForm = this.fb.group({
      'spec': ['', Validators.required],
      'place': ['', Validators.required],
      'province': ['', Validators.required],
      'city': [],
      'suburb': ['', Validators.required]
    });

    this.lookupProvForm = this.fbP.group({
      'name': [],
      'provid': []
    })

    if (this._appService.LookUpService.showGp == false) {
      this.lookupForm.controls["spec"].setValue("DENTIST");
    }

    this.sizer = setInterval(() => {
      this.size = window.innerWidth;
      if (this.size > 1280) {
        this.combined = false;
        this.seperate = true;
      }

      if (this.size <= 1280) {
        this.combined = true;
        this.seperate = false;
      }
    }, 2000);

    this.lookupForm.get('province').markAsTouched();
    console.log(this._appService.LookUpService.showJoinDate);
  }

  ngOnDestroy() {
    clearInterval(this.sizer);
  }

  LogoChange() {
    let c: string;

    c = this.lookupForm.get('spec').value;

    if (c == "DENTIST") {
      this.defaultLogo = "DRC"
    } else{
      this.defaultLogo = "PAMC"
    }

    this.lookupForm.get('province').markAsTouched();
    this.lookupForm.get('province').reset();
    this._appService.LookUpService.cities = [];
    this._appService.LookUpService.suburbs = [];
    this.lookupForm.get('city').markAsTouched();
    this.lookupForm.get('city').reset();
    this.lookupForm.get('suburb').markAsTouched();
    this.lookupForm.get('suburb').reset();
    this.cdr.detectChanges();
  }

  Search() {
    let c: Provlookup = new Provlookup();
    let hp: string = this._hpCodes;
    let count = 1;
    this.currentpage = 1;

    c.hpcodes = hp;
    c.type = this.lookupForm.get('spec').value;
    c.search = this.lookupForm.get('place').value;

    if (this._appService.LookUpService.showDropDown) {
      c.province = this.lookupForm.get('province').value;
      c.city = this.lookupForm.get('city').value;
      c.suburb = this.lookupForm.get('suburb').value;
      if (c.suburb != undefined && c.suburb != null && c.suburb != "") {
        if (c.city != undefined && c.city != null && c.city != "") {
          if (c.city.toUpperCase() == c.suburb.toUpperCase()) {
            c.suburb = "";
          }
        } else {
          c.city = "";
        }
      }

    }

    this._appService.LookUpService.SearchProviders(c);

  }

  SearchProv() {
    let c: Provlookup = new Provlookup();
    let hp: string = this._hpCodes;
    let count = 1;
    this.currentpage = 1;

    c.hpcodes = hp;
    c.name = this.lookupProvForm.get('name').value;
    c.provid = this.lookupProvForm.get('provid').value;

    this._appService.LookUpService.SearchProvidersPerName(c);

  }

  ClearAll() {
    this.defaultSuburb = "";
    this.lookupForm.get('spec').reset();
    this._appService.LookUpService.provList = [];
    this.lookupForm.get('province').reset();
    this._appService.LookUpService.cities = [];
    this._appService.LookUpService.suburbs = [];
    this._appService.LookUpService.provList = [];
    this._appService.LookUpService.temList = [];
    this._appService.LookUpService.totalPages = 0;
    this.lookupForm.get('city').reset();
    this.lookupForm.get('suburb').reset();
    this.currentpage = 1;
    this._appService.LookUpService.found = true;
  }
  ClearAllProv() {
    this._appService.LookUpService.provList = [];
    this._appService.LookUpService.cities = [];
    this._appService.LookUpService.suburbs = [];
    this._appService.LookUpService.provList = [];
    this._appService.LookUpService.temList = [];
    this._appService.LookUpService.totalPages = 0;
    this.lookupProvForm.get('name').reset();
    this.lookupProvForm.get('provid').reset();
    this.lookupProvForm.reset();

    this.currentpage = 1;
    this._appService.LookUpService.found = true;
  }

  IncPage() {
    let page = this.currentpage + 1;
    if (page > this._appService.LookUpService.totalPages) {

    } else {
      this.currentpage++;
      this._appService.LookUpService.temList = [];
      this._appService.LookUpService.temList = this._appService.LookUpService.provList.filter((a) => { if (a.page == this.currentpage) { return a } });
    }

  }

  DecPage() {
    let page = this.currentpage - 1;
    if (page < 1) {

    } else {
      this.currentpage--;
      this._appService.LookUpService.temList = [];
      this._appService.LookUpService.temList = this._appService.LookUpService.provList.filter((a) => { if (a.page == this.currentpage) { return a } });
    }
  }

  ProvChange() {
    let c = this.lookupForm.get('province').value;
    let d: PlaceDropDown = new PlaceDropDown();
    let e = this.lookupForm.get('spec').value;
    this.defaultSuburb = "";
    d.province = c;

    if (e == 'GP') {
      d.gp = true;
      d.dentist = false;
    }
    if (e == 'DENTIST') {
      d.dentist = true;
      d.gp = false;
    }

    this._appService.LookUpService.cities = [];
    this._appService.LookUpService.suburbs = [];
    this._appService.LookUpService.GetCities(d);    
    this.lookupForm.get('city').markAsTouched();
    this.lookupForm.get('city').reset();
    this.lookupForm.get('suburb').markAsTouched();
    this.lookupForm.get('suburb').reset();
    this.cdr.detectChanges();
  }

  CityChange() {
    let e = this.lookupForm.get('province').value;
    let c = this.lookupForm.get('city').value;
    let d: PlaceDropDown = new PlaceDropDown();

    d.city = c;
    d.province = e;

    let r = this.lookupForm.get('spec').value;

    if (r == 'GP') {
      d.gp = true;
      d.dentist = false;
    }
    if (r == 'DENTIST') {
      d.dentist = true;
      d.gp = false;
    }
    this.defaultSuburb = c;
    this._appService.LookUpService.suburbs = [];
    this.lookupForm.get('suburb').markAsTouched();
    this.lookupForm.get('suburb').reset();
    this._appService.LookUpService.GetSuburbs(d);    
    this.cdr.detectChanges();
  }
}
